import gql from 'graphql-tag';
import { type BudgetSupportTypesQuery } from 'src/app/shared/graphql/jobs/get-default-service-category-query.graphql.autogenerated';

export type GetDefaultServiceCategoryQueryResult =
  BudgetSupportTypesQuery['budgetSupportTypes']['defaultBudgetSupportTypes'];

export const BudgetSupportTypesDocument = gql`
  query budgetSupportTypes($consumerUserId: ID, $postedJobId: ID) {
    budgetSupportTypes(postedJobId: $postedJobId, consumerUserId: $consumerUserId) {
      defaultBudgetSupportTypes {
        id
        name
        displayName
        isAdminOnlyType
      }
    }
  }
`;
